module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/point_03-41aefcf0beaf516f93d1f952975f4821.png";